// extracted by mini-css-extract-plugin
module.exports = {"table":"PaymentTable_table__21k-1","planCol":"PaymentTable_planCol__2SASQ"};